import { Modal } from "./ui/Modal";
import { DocMeta } from "../App";
import { Ingredient } from "./IngredientsSection";

interface ListPickerModalProps {
  pickingFor: Ingredient | null;
  lists: DocMeta[];
  onClose: () => void;
  onSelect: (listDoc: DocMeta) => void;
}

export function ListPickerModal({ pickingFor, lists, onClose, onSelect }: ListPickerModalProps) {
  if (!pickingFor) return null;

  const label = pickingFor.measurement
    ? `${pickingFor.measurement} ${pickingFor.ingredient}`
    : pickingFor.ingredient;

  return (
    <Modal
      open={true}
      onClose={onClose}
      title="Add to which list?"
    >
      <h3>Add to which list?</h3>
      <p style={{ color: "var(--color-hint)", fontSize: "14px", marginBottom: "12px" }}>
        {label}
      </p>
      {lists.length === 0 ? (
        <p style={{ color: "var(--color-muted)" }}>No lists yet. Create a list first.</p>
      ) : (
        <ul className="list-picker">
          {lists.map((l) => (
            <li key={l.docId}>
              <button className="list-picker-item" onClick={() => onSelect(l)}>
                {l.title}
              </button>
            </li>
          ))}
        </ul>
      )}
      <button
        onClick={onClose}
        className="btn-secondary btn-full"
        style={{ marginTop: "12px" }}
      >
        Cancel
      </button>
    </Modal>
  );
}
